import type { RouteRecordRaw } from 'vue-router';

import AuthProcessPage from '@/views/AuthProcessPage.vue';
import LoginPage from '@/views/LoginPage.vue';
import LogoutPage from '@/views/LogoutPage.vue';

export enum AuthRoutesEnum {
  login = '/auth/login',
  process = '/auth/process',
  logout = '/auth/logout',
}

const AuthRoutes: RouteRecordRaw = {
  path: '/auth',
  name: 'auth',
  component: () => import('../layouts/EmptyLayout.vue'),
  redirect: { name: 'Login' },
  children: [
    {
      name: 'Login',
      path: AuthRoutesEnum.login,
      component: LoginPage,
    },
    {
      path: AuthRoutesEnum.process,
      children: [
        {
          name: 'Process',
          path: '',
          component: AuthProcessPage,
        },
      ],
    },
    {
      path: AuthRoutesEnum.logout,
      name: 'Logout',
      component: LogoutPage,
    },
  ],
};

export default AuthRoutes;
